<template>
    <SelectAsync
        :label="label"
        :optionsValue="optionsValue"
        :optionsLabel="optionsLabel"
        :options="optionsComponent"
        :endpoint="endpoint"
        :fetchConfig="fetchConfig"
        :value.sync="valueComponent"
        :typeSelect="typeSelect"
        :size="size"
        :placeholder="placeholder"
        :horizontal="horizontal"
    />
</template>

<script>
/** Components */
import SelectAsync from "£lement/SelectAsync";

/** Mixins */
import baseMixin from "~/mixins/base";

/** Others */
import { mapGetters } from "vuex";

export default {
    name: "SelectFields",
    mixins: [baseMixin],
    components: {
        SelectAsync,
    },
    props: {
        isValid: {
            type: Boolean,
            default: null,
        },
        label: {
            type: String,
            default: null,
        },
        value: {
            default: null,
        },
        horizontal: {
            default: false,
        },
        placeholder: {
            type: String,
            default: null,
        },
        size: {
            default: undefined,
        },
        optionsValue: {
            default: "id",
        },
        optionsLabel: {
            default: "name",
        },
        typeSelect: {
            default: "CSelect",
        },
        advanceMode: {
            default: false,
            type: Boolean
        },
        uses:{
            default: "ALL"
        }
    },
    data() {
        return {
            valueComponent: this.value,
            optionsComponent: []
        };
    },
    computed: {
        ...mapGetters({
            storeGlobalFields: "global/fields",
            storeGlobalFieldsAdvance: "global/fieldsAdvance",
        }),
        endpoint() {
            return this.advanceMode == true ? "/fields" : "field";
        },
        fetchConfig() {
            if (this.advanceMode === true) {
                return {
                    baseURL: this.ApiCore,
                };
            }
            return {};
        },
    },
    watch: {
        value() {
            this.valueComponent = this.value;
        },
        valueComponent() {
            this.$emit("update:value", this.valueComponent);
        },
        optionsComponent() {
            this.storeFields();
        },
        advanceMode(newValue, oldValue) {
            this.loadFieds();
        },
    },
    methods: {
        storeFields: async function () {
            if (this.advanceMode) {
                this.$store.dispatch("global/saveFieldsAdvance", {
                    fields: this.optionsComponent,
                });
            } else {
                this.$store.dispatch("global/saveFields", {
                    fields: this.optionsComponent,
                });
            }
        },
        loadFieds() {

            if (this.advanceMode && this.storeGlobalFieldsAdvance.length > 0) {
                this.optionsComponent = this.storeGlobalFieldsAdvance.filter(
                    (field) =>
                        this.listToArray(field.uses).includes(this.uses) ||
                        this.listToArray(field.uses).includes("ALL")
                );
            } else if (this.storeGlobalFields.length > 0) {
                this.optionsComponent = this.storeGlobalFields;
            }
        },
    },
    created() {
        this.loadFieds();
    },
};
</script>
<style>
</style>